"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Scissors } from "lucide-react";
export default function ElevatingRealEstateValue() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="249092" id="elevating-real-estate-value" className="dark bg-background text-foreground relative min-h-screen flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/modern_glass_steel_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/modern_glass_steel_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/modern_glass_steel_architecture.png-wvc-sizes" alt="Modern glass and steel building architecture" className="w-full h-full object-cover object-center" loading="eager" />
        {}
        <div className="absolute inset-0 bg-background/40" />
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(circle at var(--mouse-x, 50%) var(--mouse-y, 50%), hsla(38,44%,52%,0.15) 0%, transparent 60%)"
      }} />
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to right, hsl(0 0% 4% / 0.8) 0%, hsl(0 0% 4% / 0.4) 55%, hsl(0 0% 4% / 0.2) 100%)"
      }} />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-24 md:py-32 flex flex-col justify-center min-h-screen">
        <div className="w-full lg:w-[60%] flex flex-col gap-8">
          {}
          <div ref={headingRef} className={`transition-all duration-700 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="inline-flex items-center gap-2 text-xs font-default font-semibold tracking-widest uppercase px-4 py-2 rounded-md border" style={{
            color: "var(--primary)",
            borderColor: "var(--primary)",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(12px)"
          }}>
              
              Lorenzo Cabason Real Estate
            </span>

            {}
            <h1 className="font-serif font-bold text-5xl md:text-6xl lg:text-8xl leading-tight mt-6" style={{
            color: "var(--foreground)",
            letterSpacing: "-0.02em"
          }}>
              ELEVATING THE
              <br />
              <span style={{
              color: "var(--primary)"
            }}>STANDARD</span>
            </h1>

            {}
            <p className="font-default text-lg md:text-xl mt-6 max-w-xl leading-relaxed" style={{
            color: "var(--muted-foreground)"
          }}>Providing exceptional value to infill builders, home buyers, and investors through strategic property management and expert real estate consulting.</p>
          </div>

          {}
          <div ref={ctaRef} className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Button asChild size="lg" className="font-default font-semibold text-base px-8 py-6 h-auto rounded-md shadow-lg transition-all duration-200 hover:opacity-90 hover:scale-105" style={{
            backgroundColor: "var(--primary)",
            color: "var(--primary-foreground)"
          }}>
              
            </Button>

            <Button asChild size="lg" variant="outline" className="font-default font-semibold text-base px-8 py-6 h-auto rounded-md transition-all duration-200 hover:scale-105" style={{
            borderColor: "var(--foreground)",
            color: "var(--foreground)",
            backgroundColor: "transparent"
          }}>
              <Link to="/ManagementPage">
                Manage My Property
              </Link>
            </Button>
          </div>

          {}
          <div className={`flex flex-wrap items-center gap-6 pt-4 transition-all duration-700 delay-400 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {[{
            label: "Portfolio Value",
            value: "$500M+"
          }, {
            label: "Infill Projects",
            value: "120+"
          }, {
            label: "Client Retention",
            value: "98%"
          }].map((stat, i) => <div data-index={i} key={i} className="flex flex-col">
                <span className="font-default font-bold text-2xl" style={{
              color: "var(--primary)"
            }}>
                  {stat.value}
                </span>
                <span className="font-default text-xs uppercase tracking-widest" style={{
              color: "var(--muted-foreground)"
            }}>
                  {stat.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-24 z-10" style={{
      background: "linear-gradient(to top, var(--background) 0%, transparent 100%)"
    }} />
    </section>;
}